import Vue from 'vue'
import Router from 'vue-router'

const Lander = () => import('@/flows/Lander/Lander')
const Solution = () => import('@/flows/Solution/Solution')
const Verify = () => import('@/flows/Verify/Verify')
const Unsubscribe = () => import('@/flows/Unsubscribe/Unsubscribe')
const Subscribe = () => import('@/flows/Subscribe/Subscribe')
const Privacy = () => import('@/flows/Privacy/Privacy')
const TermsOfService = () => import('@/flows/TermsOfService/TermsOfService')
const Press = () => import('@/flows/Press/Press')
const NotFound = () => import('@/flows/NotFound/NotFound')
const CoverLetterGenerator = () => import('@/components/CoverLetterGenerator/CoverLetterGenerator')
const Invite = () => import('@/flows/Invite/Invite')
const ThanksForSubscribing = () => import('@/flows/ThanksForSubscribing/ThanksForSubscribing')
const Success = () => import('@/flows/Success/Success')
const Settings = () => import('@/components/UserSettings/UserSettings')
const Problems = () => import('@/components/Problems/Problems')
const AffiliateDashboard = () => import('@/flows/AffiliateDashboard/AffiliateDashboard')
const Connect = () => import('@/flows/Connect/Connect')
const ConnectedStripe = () => import('@/flows/ConnectedStripe/ConnectedStripe')
const Techlead = () => import('@/flows/Techlead/Techlead')
const IcedOut = () => import('@/flows/IcedOut/IcedOut')
const Zadie = () => import('@/flows/Zadie/Zadie')
const Joma = () => import('@/flows/Joma/Joma')
const Rachit = () => import('@/flows/Rachit/Rachit')
const Algoexpert = () => import('@/flows/Algoexpert/Algoexpert')
const Levels = () => import('@/flows/Levels/Levels')
const Zhiachong = () => import('@/flows/Zhiachong/Zhiachong')
const Forrest = () => import('@/flows/Forrest/Forrest')
const Grind = () => import('@/flows/Grind/Grind')
const Stackabuse = () => import('@/flows/Stackabuse/Stackabuse')
const CrashCourse = () => import('@/flows/CrashCourse/CrashCourse')
const Nimda = () => import('@/flows/Nimda/Nimda')

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Lander',
			component: Lander
		},
		{
      path: '/problems/:userId',
			name: 'Problems',
			component: Problems,
    },
    {
      path: '/settings/:userId',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/solution/:problemId?',
			name: 'Solution',
			component: Solution,
		},
    {
      path: '/affiliates/:affiliateId',
      name: 'AffiliateDashboard',
      component: AffiliateDashboard,
    },
		{
			path: '/coverletter',
			name: 'CoverLetterGenerator',
			component: CoverLetterGenerator,
		},
		{
			path: '/verify',
			name: 'Verify',
			component: Verify,
		},
		{
			path: '/unsubscribe',
			name: 'Unsubscribe',
			component: Unsubscribe,
		},
		{
			path: '/subscribe',
			name: 'subscribe',
			component: Subscribe
		},
		{
			path: '/privacy',
			name: 'Privacy',
			component: Privacy
		},
    {
      path: '/invite',
      name: 'Invite',
      component: Invite,
    },
    {
      path: '/thanks-for-subscribing',
      name: 'ThanksForSubscribing',
      component: ThanksForSubscribing,
    },
    {
      path: '/success',
      name: 'Success',
      component: Success,
    },
		{
			path: '/terms-of-service',
			name: 'TermsOfService',
			component: TermsOfService
		},
		{
			path: '/press',
			name: 'Press',
			component: Press
		},
    {
      path: '/connect',
      name: 'Connect',
      component: Connect,
    },
    {
      path: '/connected-stripe',
      name: 'ConnectedStripe',
      component: ConnectedStripe,
    },
    {
      path: '/techlead',
      name: 'Techlead',
      component: Techlead,
    },
    {
      path: '/icedout',
      name: 'IcedOut',
      component: IcedOut,
    },
    {
      path: '/rachit',
      name: 'Rachit',
      component: Rachit,
    },
    {
      path: '/algoexpert',
      name: 'Algoexpert',
      component: Algoexpert,
    },
    {
      path: '/levels',
      name: 'Levels',
      component: Levels,
    },
    {
      path: '/zhiachong',
      name: 'Zhiachong',
      component: Zhiachong,
    },
    {
      path: '/joma',
      name: 'Joma',
      component: Joma,
    },
    {
      path: '/grind',
      name: 'Grind',
      component: Grind,
    },
    {
      path: '/forrest',
      name: 'Forrest',
      component: Forrest,
    },
    {
      path: '/stackabuse',
      name: 'Stackabuse',
      component: Stackabuse,
    },
    {
      path: '/crash-course',
      name: 'CrashCourse',
      component: CrashCourse,
    },
    {
      path: '/zadie',
      name: 'Zadie',
      component: Zadie,
    },
    {
      path: '/nimda',
      name: 'Nimda',
      component: Nimda,
    },
		{
			path: '*',
			component: NotFound
		},
	],
	mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js